var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.815,15.26331a.417.417,0,0,1-.57831-.11585.41738.41738,0,0,1,.11579-.57831l5.235-3.48919-2.92083-2.0083v-6.655A.41574.41574,0,0,0,18.25,2H5.75a.41628.41628,0,0,0-.41669.41663v6.655l-2.92,2.0083,5.235,3.48919a.41705.41705,0,1,1-.46247.69416L2,11.80585v8.52661A1.66908,1.66908,0,0,0,3.66669,22H20.33331A1.66908,1.66908,0,0,0,22,20.33246V11.80585Zm2.59418,4.08a.4182.4182,0,0,1-.58588.065l-4.05249-3.2425H9.23l-4.05249,3.2425a.41678.41678,0,1,1-.52081-.65082L8.8233,15.42413a.417.417,0,0,1,.26-.09082h5.83338a.41724.41724,0,0,1,.2608.09082l4.16669,3.33338A.41776.41776,0,0,1,19.40918,19.34332Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.f99fa4b0fa308b74a0a2a5ca659dbff3.svg";
export { ForwardRef as ReactComponent };